import { createAction } from '@reduxjs/toolkit';

// eslint-disable-next-line import/prefer-default-export
export const setLoader = createAction('loader/setLoader', (loader, isLoading) => ({
  payload: {
    loader,
    isLoading,
  },
}));
